import { usePaginationCore } from './usePaginationCore';
import { createScroll, createDataMerge } from './plugins';

/**
 * Mobile端 滚动加载 - 简化版插件化组合实现
 * @param {Object} options 配置选项
 * @param {Function} options.bindChange 数据变化时的回调函数
 * @returns {Object} Mobile端分页相关的响应式数据和方法
 */
export const usePaginationMobile = (options = {}) => {
	const { bindChange } = options;

	// 创建核心分页实例，移动端默认页大小为20
	const pagination = usePaginationCore({
		defaultSize: 20,
		bindChange
	});
	// 插件注册：数据拼装
	pagination.use(createDataMerge());
	// 插件注册：滚动加载
	pagination.use(createScroll());

	const scroll = pagination.pluginContext.scroll;
	const dataMerge = pagination.pluginContext.dataMerge;

	// 返回组合后的API
	return {
		// 核心分页状态和方法
		...pagination,

		// 数据管理方法
		finalData: dataMerge.finalData,
		resetFinalData: dataMerge.resetFinalData,
		appendFinalData: dataMerge.appendFinalData,
		setData: dataMerge.setData, // 快捷赋值接口

		// 滚动加载状态和方法
		hasMoreData: scroll?.hasMoreData,
		onPullDown: scroll?.onPullDown,
		onPullUp: scroll?.onPullUp
	};
};
